import styled, { css } from 'styled-components'

interface ContainerProps {
    size?: 'tiny' | 'small' | 'normal' | 'large' | 'huge'
    $noPadding?: boolean
}

const Container = styled.div<ContainerProps>`
    width: 100%;
    margin: 0 auto;
    max-width: ${(p) => p.theme.containerWidth[p.size || 'large']};

    ${(p) =>
        !p.$noPadding &&
        css`
            padding: 0 20px;
        `};
`

export default Container
